import React from 'react';
import { motion } from 'framer-motion';
import UserTypesJourney from './comprehensive-findings/UserTypesJourney';
import DeeperBarriers from './comprehensive-findings/DeeperBarriers';
import NeedsMotivationsAspirations from './comprehensive-findings/NeedsMotivationsAspirations';
import PantryRecruitmentGap from './comprehensive-findings/PantryRecruitmentGap';
import Recommendations from './comprehensive-findings/Recommendations';
import Appreciation from './comprehensive-findings/Appreciation';
import './ComprehensiveFindingsSection.css';

const ComprehensiveFindingsSection: React.FC = () => {
  return (
    <section className="tmf-comprehensive-findings">
      <div className="tmf-container">
        {/* Section Header */}
        <motion.div
          className="tmf-cf-header"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <h2 className="tmf-cf-main-title">Comprehensive Findings</h2>
          <p className="tmf-cf-main-subtitle">
            Synthesizing research insights into actionable understanding
          </p>
        </motion.div>

        {/* Category 1: Surface Level Issue - Awareness */}
        <motion.div
          className="tmf-cf-section"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.1 }}
        >
          <div className="tmf-cf-section-header">
            <h3 className="tmf-cf-section-title">Surface Level Issue: Awareness</h3>
            <p className="tmf-cf-section-subtitle">
              Understanding the awareness journey from discovery to engagement
            </p>
          </div>
          <UserTypesJourney />
        </motion.div>

        {/* Category 2: Deeper Barriers */}
        <motion.div
          className="tmf-cf-section"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.1 }}
        >
          <div className="tmf-cf-section-header">
            <h3 className="tmf-cf-section-title">Deeper Barriers</h3>
            <p className="tmf-cf-section-subtitle">
              Systemic challenges that prevent service access and engagement
            </p>
          </div>
          <DeeperBarriers />
        </motion.div>

        {/* Category 3: Needs / Motivations / Aspirations */}
        <motion.div
          className="tmf-cf-section"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.1 }}
        >
          <div className="tmf-cf-section-header">
            <h3 className="tmf-cf-section-title">Needs / Motivations / Aspirations</h3>
            <p className="tmf-cf-section-subtitle">
              What drives community members and what they hope to achieve
            </p>
          </div>
          <NeedsMotivationsAspirations />
        </motion.div>

        {/* Category 4: Pantry as Recruitment Gap */}
        <motion.div
          className="tmf-cf-section"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.1 }}
        >
          <div className="tmf-cf-section-header">
            <h3 className="tmf-cf-section-title">Pantry as a Recruitment Gap</h3>
            <p className="tmf-cf-section-subtitle">
              Why the pantry visit isn't an effective service recruitment moment
            </p>
          </div>
          <PantryRecruitmentGap />
        </motion.div>

        {/* Category 5: Recommendations */}
        <motion.div
          className="tmf-cf-section"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.1 }}
        >
          <div className="tmf-cf-section-header">
            <h3 className="tmf-cf-section-title">Recommendations</h3>
            <p className="tmf-cf-section-subtitle">
              Strategic interventions to improve service awareness and access
            </p>
          </div>
          <Recommendations />
        </motion.div>

        {/* Category 6: Appreciation */}
        <motion.div
          className="tmf-cf-section"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.1 }}
        >
          <div className="tmf-cf-section-header">
            <h3 className="tmf-cf-section-title">
              What's Working Well
              <motion.span
                className="tmf-cf-title-sticker"
                initial={{ scale: 0, rotate: -180 }}
                whileInView={{ scale: 1, rotate: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8, delay: 0.3, ease: 'backOut' }}
              >
                😊
              </motion.span>
            </h3>
            <p className="tmf-cf-section-subtitle">
              Community voices highlighting SECS's positive impact
            </p>
          </div>
          <Appreciation />
        </motion.div>
      </div>
    </section>
  );
};

export default ComprehensiveFindingsSection;
